import api from './';

export default {
  apiGetBuildings: params => api.post('/building/index', params),
  apiCreateBuilding: params => api.post('/building/add', params),
  apiEditBuilding: params => api.post('/building/edit', params),
  apiDeleteBuilding: params => api.post('/building/del', params),
  apiGetMettings: params => api.post('/meeting/index', params),
  apiCreateMetting: params => api.post('/meeting/add', params),
  apiEditMeeting: params => api.post('/meeting/edit', params),
  apiDeleteMetting: params => api.post('/meeting/del', params),
  apiGetProducts: params => api.post('/product/index', params),
  apiAddProduct: params => api.post('/product/add', params),
  apiEditProduct: params => api.post('/product/edit', params),
  apiGetProductDetail: params => api.post('/product/detail', params),
  apiUpload: params => api.post('/user/upload', params, {
    headers: { "Content-Type": "multipart/form-data" }
  }),
  apiDeleteProduct: params => api.post('/product/del', params),
  apiAddMulti: params => api.post('/product/multiAdd', params),
  apiGetProductExtra: params => api.post('/product/getProductExtendList'),
  apiAddProductExtra: params => api.post('/product/addExtendNode', params),
  apiEditProdctExtra: params => api.post('/product/editExtendNode', params),
  apiGetExtraByProduct: params => api.post('/product/getProductExtendListByProductId', params),
  apiAddExtra: params => api.post('/product/addExtendValue', params),
  apiAddExtra: params => api.post('/product/addExtendValue', params),
  apiEditExtra: params => api.post('/product/editExtendValue', params),
  apiDelExtra: params => api.post('/product/delExtendValue', params),
  apiGetTempl: params => api.post('/product/getExcelTpl', params),
  apiGetFields: () => api.post('/product/getFields'),
  apiGetDetail: params => api.post('/product/detail', params),
  apiDownloadQrcode: params => api.post('https://sms.zhaodaka.net/api/v1.0/qrcode/job/create.json', params),
  apiGetQrCodeLink: params => api.post('https://sms.zhaodaka.net/api/v1.0/qrcode/job/query.json', params)
};



// WEBPACK FOOTER //
// ./src/api/product.js